/**
 * Soft-launch gate for Email two-step verification.
 * Set REACT_APP_MFA_SOFT_LAUNCH=true when BE MFA endpoints are available.
 * Set REACT_APP_MFA_GRACE_ENDS_AT to an ISO date (end of optional 14-day window).
 */
export const IS_MFA_SOFT_LAUNCH_ENABLED =
  process.env.REACT_APP_MFA_SOFT_LAUNCH === "true";

export const MFA_GRACE_ENDS_AT = process.env.REACT_APP_MFA_GRACE_ENDS_AT ?? "";
